export default "__VITE_ASSET__B$ZMuEvl__"